import React, { useState, useEffect } from 'react';

const ServiceProcessSection = ({ title, subtitle, steps, icons }) => {
  const [currentStep, setCurrentStep] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentStep((prev) => (prev + 1) % steps.length);
    }, 4000);

    return () => clearInterval(interval);
  }, [steps.length]);

  return (
    <section className="py-16 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            {title}
          </h2>
          <p className="text-lg text-gray-600">
            {subtitle}
          </p>
        </div>

        {/* Desktop View */}
        <div className="hidden md:grid md:grid-cols-3 gap-8">
          {steps.map((step, index) => {
            const Icon = icons[step.icon];
            return (
              <div
                key={index}
                className="text-center p-6 rounded-lg bg-gray-50 hover:bg-brand-50 transition-all cursor-pointer"
              >
                <div className="inline-flex items-center justify-center w-16 h-16 bg-brand-500 text-white rounded-full mb-4">
                  <Icon className="h-8 w-8" />
                </div>
                <div className="text-brand-500 font-bold text-lg mb-2">Step {index + 1}</div>
                <h3 className="text-xl font-semibold text-gray-900 mb-3">{step.title}</h3>
                <p className="text-gray-600">{step.description}</p>
              </div>
            );
          })}
        </div>

        {/* Mobile Slider */}
        <div className="md:hidden">
          <div className="relative">
            {steps.map((step, index) => {
              const Icon = icons[step.icon];
              return (
                <div
                  key={index}
                  className={`text-center p-6 rounded-lg bg-gray-50 transition-opacity duration-500 ${
                    index === currentStep ? 'opacity-100' : 'opacity-0 absolute inset-0'
                  }`}
                >
                  <div className="inline-flex items-center justify-center w-16 h-16 bg-brand-500 text-white rounded-full mb-4">
                    <Icon className="h-8 w-8" />
                  </div>
                  <div className="text-brand-500 font-bold text-lg mb-2">Step {index + 1}</div>
                  <h3 className="text-xl font-semibold text-gray-900 mb-3">{step.title}</h3>
                  <p className="text-gray-600">{step.description}</p>
                </div>
              );
            })}
          </div>

          <div className="flex justify-center mt-6 space-x-2">
            {steps.map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrentStep(index)}
                className={`h-2 rounded-full transition-all ${
                  index === currentStep ? 'w-8 bg-brand-500' : 'w-2 bg-gray-300'
                }`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServiceProcessSection;